import React from 'react';
import PropTypes from 'prop-types';
import Svg from '../shared/Svg';
import { Tooltip } from '../shared/Tooltip';
import colors from '../../utils/colors';
import { useSelector } from 'react-redux';
import './StatusBarAlert.scss';

const getStatusConfig = (alertStatus) => {
  switch (alertStatus) {
    case 'success':
      return ['alert-success', '/assets/success.svg'];
    case 'info':
      return ['alert-success', '/assets/info.svg'];
    default:
      return ['alert-error', '/assets/error.svg'];
  }
};

export const StatusBarAlert = ({ text, status }) => {
  const alertText = text || useSelector((state) => state.app.alertText);
  const alertStatus = status || useSelector((state) => state.app.alertStatus);
  const alertRedirectLink = useSelector((state) => state?.salesforceRecords?.salesforceRecordRedirectLink);
  const alertPopOutText = useSelector((state) => state?.salesforceRecords?.salesforceRecordTooltipContent);

  const [statusClass, statusImage] = getStatusConfig(alertStatus);
  const alertWithLink = alertRedirectLink ? 'alert-with-link' : '';
  return (
    <div className={`alert-container ${statusClass} ${alertWithLink}`}>
      <Svg
        className={'alert-icon'}
        data={statusImage}
        fill={colors.white}
      />
      {alertPopOutText ?
      <Tooltip textContent={alertPopOutText}><div className="alert-text">
        {alertText} {alertRedirectLink && (
          <div className='alert-link' onClick={() => window.open(alertRedirectLink)}>View in Litify</div>)}
      </div></Tooltip> :
      <div className="alert-text">
        {alertText} {alertRedirectLink && (
          <div className='alert-link' onClick={() => window.open(alertRedirectLink)}>View in Litify</div>)}
      </div>}
    </div>
  );
};

StatusBarAlert.propTypes = {
  text: PropTypes.string,
  status: PropTypes.string,
};
